import { CSSObject } from '@emotion/react'
import { FontWeight, Typography } from '@opallabs/gem'
import { colors } from '@opallabs/spectrum'

const getContainerStyles = (
  width: number,
  emptyContainer: boolean,
  isDragging: boolean
): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  width: emptyContainer ? `calc(${width}px - 2px)` : `calc(${width}px + 200px)`,
  userSelect: isDragging ? 'none' : 'inherit',
})

const emptyContainerStyles: CSSObject = {
  border: `1px solid ${colors.n5.base}`,
  display: 'flex',
  height: '145px',
  textAlign: 'center',
  width: '100%',
}

const emptyTextStyles: CSSObject = {
  color: colors.n5.base,
  fontSize: Typography.M500.fontSize,
  fontWeight: FontWeight.Semibold,
  margin: 'auto',
}

const buttonContainerStyle: CSSObject = {
  marginTop: '20px',
}

const styles = {
  getContainerStyles,
  emptyContainerStyles,
  emptyTextStyles,
  buttonContainerStyle,
}

export { styles }
